<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="musicWrap preview" :class="{ playing: isPlaying }">
    <img
      v-if="customIconSrc"
      class="music-icon-img"
      :src="customIconSrc"
      alt=""
    />
    <i v-else :class="['iconfont', 'icon-ic_music']"></i>
    <span v-if="isPreview" class="preview-media-badge">{{ statusText }}</span>
  </div>
</template>

<script>
import previewMediaMixin from "@/utils/previewMediaMixin";
import { getMusicControlIconSrc } from "@/utils/musicExt";

export default {
  mixins: [previewMediaMixin],
  props: {
    element: {
      type: Object,
      default: () => ({}),
    },
    isPreview: Boolean,
  },
  data() {
    return {
      status: "idle",
      muted: false,
      volume: 50,
    };
  },
  computed: {
    customIconSrc() {
      return getMusicControlIconSrc(this.element.style || {});
    },
    isPlaying() {
      return this.status === "play" || this.status === "continue";
    },
    statusText() {
      if (this.muted) {
        return "静音";
      }
      const map = {
        idle: "待机",
        play: "播放中",
        pause: "已暂停",
        continue: "播放中",
        stop: "已停止",
        replay: "重播",
      };
      return map[this.status] || this.status;
    },
  },
  methods: {
    handlePreviewMediaEvent(event) {
      switch (event) {
        case "play":
        case "replay":
        case "continue":
          this.status = event === "continue" ? "continue" : "play";
          break;
        case "pause":
          this.status = "pause";
          break;
        case "stop":
          this.status = "stop";
          break;
        case "volumeUp":
          this.volume = Math.min(100, this.volume + 10);
          this.$message.success(`音量 ${this.volume}`);
          break;
        case "volumeDown":
          this.volume = Math.max(0, this.volume - 10);
          this.$message.success(`音量 ${this.volume}`);
          break;
        case "mute":
          this.muted = true;
          break;
        case "unmute":
          this.muted = false;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.musicWrap {
  .iconfont {
    font-size: inherit;
  }
}
</style>
<style lang="scss" scoped>
.musicWrap {
  width: 100%;
  height: 100%;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &.playing {
    color: #409eff;
  }
}
.music-icon-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  pointer-events: none;
}
.musicWrap.playing .music-icon-img {
  filter: brightness(1.05) saturate(1.2);
}
.preview-media-badge {
  position: absolute;
  right: 6px;
  bottom: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 12px;
  line-height: 1.4;
  pointer-events: none;
}
</style>
